/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sorx_Hint_Rate_LimitedInputs */

const en_sorx_hint_rate_limited = /** @type {(inputs: Sorx_Hint_Rate_LimitedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bystep held some messages back so you are not flooded. The daily digest can help.`)
};

const id_sorx_hint_rate_limited = /** @type {(inputs: Sorx_Hint_Rate_LimitedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bystep menahan sebagian pesan supaya Anda tidak kebanjiran. Ringkasan harian bisa membantu.`)
};

/**
* | output |
* | --- |
* | "Bystep held some messages back so you are not flooded. The daily digest can help." |
*
* @param {Sorx_Hint_Rate_LimitedInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const sorx_hint_rate_limited = /** @type {((inputs?: Sorx_Hint_Rate_LimitedInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sorx_Hint_Rate_LimitedInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_sorx_hint_rate_limited(inputs)
	return en_sorx_hint_rate_limited(inputs)
});